<template>
  <div class="page-wrapper planAdd-wrapper">
    <div class="container-fluid">
      <breadcrumb :items="breadcrumbItems" />
      <div class="page-title">
        <h1>Assign Plan To Group
          <span v-if="groupName"> ({{ groupName }})</span>
        </h1>
      </div>
      <div>
        <employer-group-plan-select-card-list :groupId="groupId" />
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/resource/Api";
import EmployerGroupPlanSelectCardList from "./plans/EmployerGroupPlanSelectCardList";
export default {
  name: "EmployerGroupPlans",
  components: {
    EmployerGroupPlanSelectCardList
  },
  data: () => ({
    groupId: null,
    groupName: "",
    breadcrumbItems: []
  }),
  methods: {
    getBreadCrumbs() {
      this.breadcrumbItems = [
        {
          title: "Employers & Groups",
          path: {
            name: "EmployerGroupList",
          },
          active: false,
        },
        {
          title: "View / Add Plans",
          active: true,
        },
      ];
    },
    async getGroupDetail() {
      const url = `v2/get-group-details/${this.groupId}`;
      let loader = this.$loading.show();
      await Api.get(url)
      .then((res) => {
        let result = res.data.data;
        this.groupName = result?.general_info?.group_name || "";
      })
      .catch(() => {
        this.groupName = "";
      })
      .finally(() => {
        loader.hide();
      });
    }
  },
  created() {
    this.groupId = parseInt(atob(this.$route.params.groupId));
    this.getBreadCrumbs();
    this.getGroupDetail();
  },
};
</script>
<style src="@/assets/css/employer-groups.css"></style>
